import { PageModel } from "./PageModel";

class DetailBlogController extends PageModel {
}

export { DetailBlogController }
